export const ACCESS_TOKEN_OPTIONS = [
    {
        label: "Self-Contained",
        value: "self-contained"
    },
    {
        label: "Reference",
        value: "reference"
    },
];

export const TOKEN_SIGNATURE_ALGORITHM_OPTIONS= [
    {
        label: "RS256",
        value: "RS256"
    },
    {
        label: "HS384",
        value: "HS384"
    },
    {
        label: "HS512",
        value: "HS512"
    },
    {
        label: "RS384",
        value: "RS384"
    },
    {
        label: "RS512",
        value: "RS512"
    },
    {
        label: "ES256",
        value: "ES256"
    },
    {
        label: "ES384",
        value: "ES384"
    },
    {
        label: "ES512",
        value: "ES512"
    },
    {
        label: "PS256",
        value: "PS256"
    },
    {
        label: "PS384",
        value: "PS384"
    },
    {
        label: "PS512",
        value: "PS512"
    },
];

export const AUTHORIZATION_GRANT_TYPES_OPTIONS = [
    {
        label: "refresh_token",
        value: "refresh_token"
    },
    {
        label: "client_credentials",
        value: "client_credentials"
    },
    {
        label: "authorization_code",
        value: "authorization_code"
    },
    {
        label: "password",
        value: "password"
    },
];

export const CLIENT_AUTHENTICATION_METHODS = [
    {
        label: "client_secret_basic",
        value: "client_secret_basic"
    },
];